export default __webpack_public_path__ + "static/media/Coffee_rewardUnlock.cf8362b0.png";